import styled from 'styled-components';
import { animated } from '@react-spring/web';

export const PurpleGuideWrapper = styled(animated.div)`
  background-color: ${({ theme }) => theme.colors.guidePurple};
  border-radius: 0;
  width: 433px;
  position: fixed;
  z-index: 23;
  top: 60px;
  right: 0;
  bottom: 0;
  overflow: auto;
  transition: border-radius 0.3s;
  border: 2px solid ${({ theme }) => theme.colors.white};
  border-right: none;

  &.top {
    transition: border-radius 0.3s;
    border-top-left-radius: 16px;
  }

  &.bottom {
    transition: border-radius 0.3s;
    border-bottom-left-radius: 16px;
  }

  .show-mask & {
    z-index: 5;
  }
`;

export const PurpleGuideTab = styled(animated.div)`
  position: fixed;
  z-index: 7;
  background-color: ${({ theme }) => theme.colors.guidePurple};
  top: 60px;
  right: 0px;
  width: 30px;
  border-radius: 16px 0 0 16px;
  align-items: center;
  cursor: pointer;
  transition:
    color 0.2s ease,
    border-color 0.2s ease;
  border: 2px solid ${({ theme }) => theme.colors.headerGrey};
  border-right: none;

  .show-mask & {
    z-index: 5;
  }

  &:hover,
  &:focus {
    border-color: ${({ theme }) => theme.colors.white};
    transition:
      color 0.2s ease,
      border-color 0.2s ease;
  }
`;
